module.exports = __webpack_public_path__ + "img/japanese-“free-of-charge”-button.91e2ba2f.png";